import { createSlice } from "@reduxjs/toolkit";

const initialGradeCourse = {
  grade: "",
  credit: 1,
  displayOnTheSchoolReport: true,
  courses: []
}

const initialGradeCoursesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  courses: [],
  gradeCourse: initialGradeCourse
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const gradeCourseSlice = createSlice({
  name: "gradeCourses",
  initialState: initialGradeCoursesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGradeCourses
    gradeCoursesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.courses =  entities;
    },
    //getCourse
    courseFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.gradeCourse = entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanCoursesState
    coursesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
      state.gradeCourse = initialGradeCourse;
    }
  }
});